module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/stairs-88f7148b40dc89aeef795ec308b78f59.svg";